import React from 'react'

const TextArea = ({
    id,
    label,
    type,
    name,
    className,
    placeholder,
    customClass,
    value,
    onChange,
    onBlur,
    error,
    touch
}) => {
  return (
    <>
     <div>
            <label
                htmlFor={id}
                className={`block mt-2 text-sm font-medium text-gray-900 ${customClass}`}
            >
                {label}
            </label>
            <div>
                <textarea
                    name={name}
                    id={id}
                    className={`bg-gray-50 border min-h-14 border-gray-300 text-gray-900 rounded-lg block w-full p-2.5 ${className}`}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                />
                {error && touch ? <h1 className='text-xs text-red-600'>{error}</h1> : null}
            </div>
        </div>
    </>
  )
}

export default TextArea;